<template>
  <section class="faq section" id="faq">
    <h2 class="section-title">{{ $t('faq.title') }}</h2>
    <p class="section-subtitle">{{ $t('faq.subtitle') }}</p>

    <div class="faq-container">
      <div 
        v-for="(item, index) in faqs" 
        :key="index"
        class="faq-item"
        :class="{ 'active': activeIndex === index }"
      >
        <div 
          class="faq-question"
          @click="toggleAccordion(index)"
        >
          <h3>{{ item.q }}</h3>
          <div class="faq-icon">
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              stroke-width="2"
            >
              <path d="M12 5v14M5 12h14" />
            </svg>
          </div>
        </div>
        <div class="faq-answer">
          <p>{{ item.a }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import sr from '@/scrollreveal.js';

export default {
  name: 'FAQSection',
  data() {
    return { activeIndex: null };
  },
  computed: {
    faqs() {
      // $tm devuelve objetos/arrays sin necesidad de returnObjects
      return this.$tm('faq.items') || [];
    }
  },
  mounted() { sr.reveal('.faq-item', { interval: 100 }); },
  methods: {
    toggleAccordion(i) { this.activeIndex = this.activeIndex === i ? null : i; }
  }
};
</script>


<style src="@/styles/Portfolio-Section.css"></style>
